module.exports = __webpack_public_path__ + "img/_dsc8149.7f729d8f.jpg";